import { useSnackbar } from 'notistack';
import { useCallback, useState } from 'react';
import { postTopUpBalance } from '../../../../../crud/orders.crud';
import { getResponseMessage } from '../../../../../utils/utils';

export const useTopUpBlance = () => {
  const { enqueueSnackbar } = useSnackbar();
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState<any>(null);
  const [success, setSuccess] = useState(false);

  const fetchBalance = useCallback(async (amount: number, type: 'card' | 'sbp' = 'sbp', callBack?: () => void) => {
    setLoading(true);

    try {
      if (callBack) {
        await callBack(); 
        await new Promise((resolve) => setTimeout(resolve, 1800));
      }

      const res = await postTopUpBalance(amount, type);

      if (res.data?.data?.confirmation_url) {
        window.open(res.data.data.confirmation_url, '_self');
      }

    } catch (e) {
      enqueueSnackbar(`Ошибка: ${getResponseMessage(e)}`, { variant: 'error' });
    } finally {
      setLoading(false);
      setErr(null);
      setSuccess(false);
    }
  }, []);

  return [fetchBalance, success, loading, err];
};
